import { render, staticRenderFns } from "./veJkyFund.vue?vue&type=template&id=08b71522&scoped=true"
import script from "./veJkyFund.vue?vue&type=script&lang=js"
export * from "./veJkyFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b71522",
  null
  
)

export default component.exports